import { render } from "./mychoujiang.vue?vue&type=template&id=4534275c&scoped=true"
import script from "./mychoujiang.vue?vue&type=script&lang=js"
export * from "./mychoujiang.vue?vue&type=script&lang=js"

import "./mychoujiang.vue?vue&type=style&index=0&id=4534275c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4534275c"]])

export default __exports__